import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-brand-deep px-6 py-10 text-center" data-id="element-69" data-mp="32wd2qgad7ltj">
      <p className="mb-2 font-display text-[22px] font-extrabold text-white" data-id="element-70" data-mp="3ggtwodvnbb34">
        Ultimate <span className="text-brand-yellow" data-id="element-71" data-mp="32p5m4f11ouo9">Web</span> Creator
      </p>
      <p className="text-[13px] text-white/50" data-id="element-72" data-mp="36oy0j8d4dv1j">
        © 2025 Ultimate Web Creator · Webs profesionales para negocios locales ·
        Entrega en 7 días
      </p>
    </footer>;
}